module.exports = __webpack_public_path__ + "static/media/tastysinsbyari.261ca294.jpeg";